export const InvoiceDayReducer = (
    state = {
        records: [
            { dayId: 0, description: "First" },
            { dayId: 1, description: "Second" },
            { dayId: 2, description: "Third" },
            { dayId: 3, description: "Fourth" },
            { dayId: 4, description: "Last" }
        ]
    }) => { return state }